export default __webpack_public_path__ + "static/media/fi_phone-android.a01752d8.svg";